import React, { useMemo, useRef, useEffect } from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import LottieView from 'lottie-react-native';
import PropTypes from 'prop-types';

import { LightThemeColors, withTheme } from '../Themes';

import { LottieTypes, getLottieSource } from './VFLottieView.Enums';
import styles from './VFLottieView.Styles';

function VFLottieView({
  autoPlay,
  containerStyle,
  loop,
  lottieViewStyle,
  lottieViewTestID,
  source,
  type,
  theme,
  ...additionalProps
}) {
  // const lottieRef = useRef(undefined);

  const lottieSourceMemoized = useMemo(() => getLottieSource(type, theme, source));

  // useEffect(() => {
  //   if (autoPlay) {
  //     lottieRef.current?.resume();
  //   }
  // }, [theme, autoPlay]);

  return (
    <View style={containerStyle}>
      <LottieView
        // ref={lottieRef}
        style={[styles.lottieViewStyle, lottieViewStyle]}
        autoPlay={autoPlay}
        loop={loop}
        source={lottieSourceMemoized}
        testID={lottieViewTestID}
        progress={1}
        cacheComposition={false}
        {...additionalProps}
      />
    </View>
  );
}

VFLottieView.defaultProps = {
  theme: LightThemeColors,
  type: LottieTypes.spinner,
};

VFLottieView.propTypes = {
  autoPlay: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  loop: PropTypes.bool,
  lottieViewStyle: ViewPropTypes.style,
  lottieViewTestID: ViewPropTypes.testID,
  source: PropTypes.object,
  type: PropTypes.oneOf(Object.values(LottieTypes)),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};

export default withTheme(VFLottieView);
